import PropTypes from 'prop-types';
import React from 'react';

const Rust = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.12" cx="124" cy="152" r="124" fill="url(#paint0_linear_1112_10359)" />
    <circle opacity="0.12" cx="124" cy="152" r="104" fill="url(#paint1_linear_1112_10359)" />
    <mask
      id="mask0_1112_10359"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="20"
      y="48"
      width="208"
      height="208"
    >
      <circle cx="124" cy="152" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_10359)">
      <g opacity="0.8">
        <path
          d="M-348 227.27C-344.43 224.72 -340.86 222.39 -337.29 220.15C-333.39 217.72 -329.5 215.39 -325.61 213.15C-321.72 210.91 -317.82 208.59 -313.92 206.34L-302.24 199.56L-290.56 192.81C-286.66 190.57 -282.767 188.323 -278.88 186.07L-267.2 179.32L-255.5 172.56C-251.613 170.313 -247.72 168.067 -243.82 165.82L-232.14 159.07L-220.5 152.32C-216.613 150.073 -212.72 147.827 -208.82 145.58L-197.15 138.83L-185.46 132.08L-173.78 125.34L-162.07 118.56L-150.38 111.81C-146.49 109.57 -142.6 107.31 -138.69 105.07C-134.78 102.83 -130.91 100.57 -127.01 98.3198L-115.32 91.5698L-103.64 84.8198L-91.95 78.0698L-80.27 71.3298L-68.58 64.5798L-56.9 57.8398L-45.22 51.0998L-33.5 44.3998C-29.6067 42.1398 -25.7133 39.8898 -21.82 37.6498L-10.14 30.8998L1.5 24.1698L13.19 17.4298C17.0767 15.1898 20.9667 12.9632 24.86 10.7498C28.75 8.54985 32.65 6.36984 36.54 4.29984C40.43 2.22984 44.33 0.299846 48.23 -1.40015C52.0061 -3.054 55.9128 -4.39192 59.91 -5.40015C63.7331 -6.35674 67.6591 -6.84036 71.6 -6.84016C75.5158 -6.75251 79.4183 -6.35122 83.27 -5.64015C87.17 -5.00015 91.07 -4.25015 94.96 -3.97015C98.8818 -3.60548 102.837 -3.94413 106.64 -4.97015C110.889 -6.2659 114.855 -8.35246 118.33 -11.1202C122.606 -14.5558 126.517 -18.4229 130 -22.6602C131.02 -23.8602 132.02 -25.0802 133 -26.3202C133.98 -27.5602 134.96 -28.8068 135.94 -30.0602C137.86 -32.5602 139.82 -35.1602 141.72 -37.6802C145.59 -42.8302 149.57 -48.0602 153.66 -52.9302C157.407 -57.4276 161.393 -61.7204 165.6 -65.7902C167.33 -67.4502 169.04 -68.9802 170.82 -70.4702C172.6 -71.9602 174.36 -73.3302 176.16 -74.6902C178.16 -76.1802 180.16 -77.6002 182.16 -78.9902C184.16 -80.3802 186.16 -81.7202 188.16 -82.9902C190.96 -84.8202 193.8 -86.6102 221.47 -101.91"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 293.18C-345.08 290.12 -342.17 286.68 -339.25 283.04C-335.35 278.18 -331.47 272.97 -327.57 267.98C-323.67 262.99 -319.77 258.24 -315.88 253.98C-312.219 249.909 -308.322 246.056 -304.21 242.44C-300.473 239.189 -296.564 236.142 -292.5 233.31C-288.61 230.58 -284.72 228.08 -280.82 225.68C-276.92 223.28 -273.04 220.98 -269.14 218.68C-265.24 216.38 -261.35 214.14 -257.45 211.88L-245.78 205.13L-234.09 198.39L-222.41 191.64L-210.73 184.89L-199.05 178.15L-187.37 171.41C-183.483 169.164 -179.59 166.914 -175.69 164.66L-164.01 157.92L-152.32 151.18L-140.64 144.43L-128.97 137.69L-117.28 130.94L-105.59 124.2L-93.9 117.45L-82.22 110.7L-70.5 103.96L-58.81 97.2103L-47.13 90.4703L-35.5 83.7303L-23.83 76.9803L-12.15 70.2303C-8.24999 67.9836 -4.35667 65.737 -0.470001 63.4903L11.21 56.7603L22.89 50.0203C26.79 47.7703 30.67 45.5303 34.57 43.3103C38.47 41.0903 42.36 38.8803 46.25 36.7603C50.14 34.6403 54.03 32.5803 57.92 30.7603C61.7033 28.9448 65.6096 27.3977 69.61 26.1303C73.4059 24.9455 77.3246 24.1974 81.29 23.9003C85.1907 23.6906 89.1025 23.8614 92.97 24.4103C96.86 24.9203 100.76 25.6703 104.66 26.1503C108.527 26.7201 112.455 26.7504 116.33 26.2403C120.478 25.5658 124.453 24.0845 128.03 21.8803C132.322 19.1668 136.247 15.9136 139.71 12.2003C143.839 7.76707 147.738 3.12427 151.39 -1.70969C155.28 -6.70969 159.18 -12.0197 163.08 -16.9897C166.82 -21.7697 170.76 -26.5197 174.8 -30.7997C176.733 -32.8397 178.693 -34.7864 180.68 -36.6397C182.667 -38.493 184.687 -40.253 186.74 -41.9197C188.74 -43.5097 190.74 -45.0397 192.68 -46.4897C194.62 -47.9397 196.68 -49.3397 198.68 -50.6697C200.45 -51.8597 202.18 -52.9697 203.96 -54.0897C205.74 -55.2097 207.47 -56.2497 209.25 -57.3197C215.97 -61.3197 223.17 -65.5797 288.46 -101.93"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 340.56L-343.5 338.02C-339.5 335.76 -335.5 333.52 -331.56 331.41C-329.6 330.356 -327.643 329.34 -325.69 328.36C-323.69 327.36 -321.77 326.47 -319.83 325.61C-316.049 323.903 -312.141 322.495 -308.14 321.4C-304.326 320.38 -300.406 319.81 -296.46 319.7C-292.549 319.67 -288.643 319.961 -284.78 320.57C-280.88 321.12 -276.98 321.81 -273.09 322.11C-269.185 322.497 -265.244 322.268 -261.41 321.43C-257.226 320.4 -253.267 318.61 -249.73 316.15C-245.466 313.146 -241.549 309.678 -238.05 305.81C-234.15 301.64 -230.26 296.81 -226.37 291.88C-222.48 286.95 -218.57 281.88 -214.68 277.05C-210.79 272.22 -206.9 267.76 -203 263.73C-199.319 259.915 -195.419 256.319 -191.32 252.96C-187.42 249.76 -183.53 246.96 -179.64 244.28C-175.75 241.6 -171.85 239.2 -167.96 236.83C-164.07 234.46 -160.17 232.17 -156.27 229.9L-144.59 223.11L-132.91 216.36L-121.23 209.62L-109.5 202.88C-105.613 200.633 -101.72 198.386 -97.82 196.14L-86.14 189.39L-74.5 182.65L-62.81 175.9L-51.13 169.15L-39.45 162.41L-27.76 155.66L-16.07 148.91L-4.39001 142.17L7.31 135.41L18.99 128.67L30.67 121.92L42.35 115.18L54.04 108.45C57.9267 106.203 61.8167 103.976 65.71 101.77C69.6 99.5596 73.5 97.3796 77.39 95.3096C81.28 93.2396 85.18 91.3096 89.07 89.6096C92.8355 87.9373 96.7404 86.5989 100.74 85.6096C104.569 84.7031 108.496 84.2765 112.43 84.3396C116.348 84.4895 120.25 84.9374 124.1 85.6796C127.965 86.4391 131.867 86.9932 135.79 87.3396C139.734 87.6493 143.702 87.2393 147.5 86.1296C151.748 84.7503 155.705 82.5975 159.17 79.7796C163.446 76.2897 167.366 72.3839 170.87 68.1196C174.76 63.5096 178.65 58.3196 182.55 53.1696C186.45 48.0196 190.34 42.8896 194.23 38.1696C197.877 33.7536 201.766 29.5438 205.88 25.5596C209.574 22.0396 213.478 18.7469 217.57 15.6996C221.46 12.7896 225.36 10.1896 229.25 7.69957C231.203 6.45957 233.16 5.24957 235.12 4.06957C237.12 2.87957 239.02 1.71957 240.98 0.55957C244.98 -1.79376 248.96 -4.1271 252.92 -6.44043C256.88 -8.75376 260.857 -11.0538 264.85 -13.3404L275.41 -19.4504L337.94 -55.4404"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 378.751C-342.96 375.851 -337.927 372.944 -332.9 370.031L-322.33 363.931L-310.4 357.051L-298.5 350.171C-294.587 347.924 -290.677 345.694 -286.77 343.481C-282.87 341.271 -278.98 339.111 -275.09 337.081C-271.2 335.051 -267.29 333.131 -263.4 331.511C-259.621 329.902 -255.714 328.611 -251.72 327.651C-247.89 326.755 -243.973 326.289 -240.04 326.261C-236.131 326.3 -232.228 326.604 -228.36 327.171C-224.46 327.671 -220.56 328.251 -216.67 328.441C-212.748 328.692 -208.811 328.331 -205 327.371C-200.806 326.193 -196.849 324.291 -193.31 321.751C-189.049 318.668 -185.133 315.134 -181.63 311.211C-177.73 306.971 -173.85 302.051 -169.95 297.021C-166.05 291.991 -162.16 286.841 -158.26 282.021C-154.36 277.201 -150.48 272.681 -146.59 268.701C-142.916 264.939 -139.012 261.408 -134.9 258.131C-131.01 255.021 -127.12 252.271 -123.22 249.701C-119.32 247.131 -115.44 244.701 -111.54 242.391C-107.64 240.081 -103.75 237.771 -99.86 235.511C-95.97 233.251 -92.08 230.991 -88.18 228.741C-84.28 226.491 -80.4 224.241 -76.5 221.991L-64.82 215.251L-53.14 208.501L-41.45 201.751L-29.77 195.011L-18.09 188.261L-6.35999 181.561L5.32001 174.811L17.01 168.061L28.7 161.311L40.39 154.561L52.07 147.811L63.76 141.071C67.66 138.824 71.55 136.584 75.43 134.351C79.34 132.121 83.23 129.901 87.12 127.751C91.01 125.601 94.91 123.491 98.79 121.581C102.581 119.675 106.493 118.018 110.5 116.621C114.276 115.31 118.199 114.467 122.18 114.111C126.079 113.834 129.997 113.999 133.86 114.601C137.75 115.151 141.65 115.981 145.54 116.601C149.392 117.301 153.324 117.459 157.22 117.071C161.363 116.515 165.342 115.094 168.9 112.901C173.217 110.184 177.147 106.894 180.58 103.121C184.716 98.6171 188.615 93.9006 192.26 88.9907C196.15 83.8807 200.05 78.5807 203.95 73.6207C207.85 68.6607 211.73 64.0407 215.63 59.9507C219.288 56.104 223.193 52.4998 227.32 49.1607C231.21 45.9907 235.1 43.2207 239 40.6307C242.9 38.0407 246.78 35.6307 250.68 33.3007C254.58 30.9707 258.47 28.6807 262.37 26.4207C266.27 24.1607 270.18 21.8807 274.09 19.6207L286.03 12.7207L297.96 5.8407L308.5 -0.279297L337.95 -17.2793"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 312.729C-345.74 312.729 -343.48 312.939 -341.21 313.189C-337.32 313.629 -333.42 314.319 -329.53 314.749C-325.654 315.264 -321.726 315.264 -317.85 314.749C-313.711 314.088 -309.741 312.628 -306.16 310.449C-301.882 307.776 -297.964 304.567 -294.5 300.899C-290.363 296.558 -286.457 292.002 -282.8 287.249C-278.9 282.249 -275.02 277.059 -271.12 272.149C-267.22 267.239 -263.34 262.659 -259.44 258.559C-255.76 254.673 -251.86 251 -247.76 247.559C-243.86 244.309 -239.97 241.429 -236.08 238.769C-232.19 236.109 -228.29 233.639 -224.39 231.269C-220.49 228.899 -216.61 226.599 -212.71 224.319C-208.81 222.039 -204.93 219.789 -201.03 217.539L-189.35 210.779L-177.67 204.039L-165.98 197.289L-154.31 190.559L-142.62 183.809L-130.94 177.069L-119.26 170.329L-107.59 163.559L-95.9 156.819L-84.21 150.069L-72.5 143.299L-60.84 136.559L-49.15 129.809L-37.5 123.059L-25.81 116.319L-14.1 109.559L-2.41 102.809L9.26001 96.0693L20.95 89.3293L32.62 82.5593L44.3 75.8393C48.2 73.5993 52.0967 71.386 55.99 69.1993C59.88 67.0293 63.77 64.9093 67.66 62.9593C71.4547 61.017 75.3578 59.2942 79.35 57.7993C83.1219 56.397 87.0297 55.3915 91.01 54.7993C94.8856 54.2849 98.8065 54.2044 102.7 54.5593C106.59 54.8893 110.49 55.5593 114.39 56.2293C118.239 56.9595 122.153 57.2945 126.07 57.2293C130.121 57.0571 134.095 56.0637 137.75 54.3093C142.042 52.1594 145.98 49.3673 149.43 46.0293C153.629 41.9779 157.536 37.6336 161.12 33.0293C165.02 28.1593 168.9 22.8893 172.8 17.8293C176.7 12.7693 180.59 7.9593 184.5 3.5593C188.168 -0.562449 192.071 -4.46895 196.19 -8.1407C199.93 -11.4238 203.842 -14.5049 207.91 -17.3707C209.91 -18.7807 211.91 -20.1207 213.91 -21.3707C215.91 -22.6207 217.91 -23.9207 219.91 -25.1507C223.85 -27.5807 227.91 -29.9807 231.84 -32.3007C235.307 -34.394 238.803 -36.4407 242.33 -38.4407C274.2 -56.9007 306.07 -75.1507 337.94 -93.9707"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-306.5 584L-134.4 484.63L-123.84 478.56L-111.9 471.67L-99.96 464.78L-88.23 458L-76.5 451.24L-64.82 444.49L-53.14 437.75L-41.5 431L-29.83 424.26L-18.13 417.56L-6.5 410.77L5.19 404.02L16.88 397.28L28.59 390.56L40.28 383.85C44.17 381.62 48.06 379.41 51.95 377.26C55.84 375.11 59.74 373.01 63.64 371.06C67.54 369.11 71.43 367.32 75.32 365.82C79.1134 364.34 83.0192 363.167 87 362.31C90.8455 361.517 94.7546 361.072 98.68 360.98C102.58 360.89 106.46 361.12 110.36 361.35C114.26 361.58 118.14 361.79 122.04 361.68C125.976 361.604 129.892 361.101 133.72 360.18C137.777 359.161 141.699 357.66 145.4 355.71C149.504 353.542 153.415 351.026 157.09 348.19C160.98 345.24 164.87 341.88 168.77 338.4C172.67 334.92 176.55 331.32 180.45 327.85C184.35 324.38 188.24 321.04 192.14 318.03C195.854 315.11 199.756 312.438 203.82 310.03C207.564 307.853 211.476 305.981 215.52 304.43C219.339 303.003 223.239 301.804 227.2 300.84C231.11 299.84 235 299.06 238.89 298.1C242.869 297.168 246.773 295.941 250.57 294.43C254.694 292.724 258.615 290.564 262.26 287.99C266.446 284.982 270.352 281.601 273.93 277.89C277.84 273.89 281.73 269.37 285.62 264.57C289.51 259.77 293.4 254.71 297.29 249.9C301.18 245.09 305.08 240.5 308.97 236.36C316.002 228.825 323.831 222.076 332.32 216.23C334.2 214.93 336.07 213.69 337.94 212.49"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 569.76L-167.5 465.56L-156.94 459.46L-144.99 452.56C-140.99 450.26 -136.99 447.96 -132.99 445.66L-121.27 438.89L-109.58 432.15L-97.89 425.4L-86.21 418.66L-74.53 411.91L-62.85 405.17L-51.16 398.42L-39.5 391.67L-27.83 384.93C-23.93 382.683 -20.0333 380.447 -16.14 378.22C-12.25 375.99 -8.34999 373.78 -4.45999 371.63C-0.569991 369.48 3.33001 367.39 7.23001 365.46C11.0233 363.541 14.9191 361.831 18.9 360.34C22.6833 358.913 26.5944 357.851 30.58 357.17C34.443 356.543 38.3617 356.329 42.27 356.53C46.16 356.72 50.05 357.27 53.94 357.75C57.8118 358.295 61.7207 358.532 65.63 358.46C69.6236 358.344 73.5704 357.566 77.31 356.16C81.5215 354.499 85.4589 352.213 88.99 349.38C93.1722 346.011 97.078 342.312 100.67 338.32C104.55 334.12 108.45 329.5 112.35 324.84C116.25 320.18 120.13 315.49 124.03 311.05C127.93 306.61 131.81 302.43 135.71 298.61C139.61 294.79 143.5 291.37 147.4 288.21C151.3 285.05 155.18 282.21 159.08 279.55C162.98 276.89 166.88 274.45 170.77 272.23C174.66 270.01 178.57 267.98 182.46 266.23C186.247 264.486 190.153 263.016 194.15 261.83C197.961 260.706 201.879 259.983 205.84 259.67C209.734 259.44 213.639 259.52 217.52 259.91C221.42 260.25 225.32 260.75 229.2 260.98C233.102 261.302 237.029 261.107 240.88 260.4C245.026 259.499 248.968 257.831 252.5 255.48C256.783 252.588 260.704 249.194 264.18 245.37C268.07 241.21 271.97 236.37 275.86 231.37C279.75 226.37 283.65 221.1 287.54 216.18C291.43 211.26 295.32 206.66 299.21 202.59C302.878 198.756 306.783 195.156 310.9 191.81C314.79 188.66 318.68 185.89 322.57 183.31C326.46 180.73 330.36 178.31 334.26 176.01L337.91 173.84"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 531.56L-200.56 446.44L-190 440.34L-178.07 433.45L-166.13 426.56L-154.4 419.79C-150.5 417.53 -146.6 415.29 -142.71 413.03L-131.02 406.29L-119.35 399.56L-107.66 392.81L-95.99 386.07L-84.3 379.33C-80.4 377.083 -76.5067 374.846 -72.62 372.62C-68.73 370.4 -64.83 368.19 -60.93 366.04C-57.03 363.89 -53.15 361.8 -49.26 359.89C-45.4617 357.994 -41.5625 356.309 -37.58 354.84C-33.7886 353.439 -29.8751 352.394 -25.89 351.72C-22.0275 351.12 -18.1143 350.912 -14.21 351.1C-10.32 351.26 -6.42 351.76 -2.53 352.2C1.34017 352.727 5.24459 352.961 9.14999 352.9C13.1448 352.794 17.0934 352.017 20.83 350.6C25.0667 348.883 29.0053 346.507 32.5 343.56C36.7208 340.001 40.6254 336.083 44.17 331.85C48.07 327.34 51.96 322.33 55.86 317.31C59.76 312.29 63.64 307.31 67.53 302.7C71.2142 298.365 75.1159 294.219 79.22 290.28C82.9283 286.736 86.8274 283.398 90.9 280.28C94.78 277.28 98.68 274.62 102.58 272.09C106.48 269.56 110.36 267.17 114.27 264.83C118.18 262.49 122.05 260.21 125.95 257.94C129.85 255.67 133.74 253.41 137.64 251.17C141.54 248.93 145.43 246.69 149.33 244.49C153.23 242.29 157.12 240.13 161.02 238.08C164.92 236.03 168.81 234.08 172.7 232.42C176.48 230.794 180.395 229.502 184.4 228.56C188.229 227.653 192.156 227.23 196.09 227.3C200.009 227.427 203.914 227.848 207.77 228.56C211.645 229.344 215.561 229.908 219.5 230.25C223.441 230.558 227.405 230.114 231.18 228.94C235.453 227.452 239.411 225.18 242.85 222.24C247.119 218.589 251.021 214.53 254.5 210.12C258.39 205.34 262.28 199.96 266.17 194.69C270.06 189.42 273.96 184.26 277.85 179.64C281.472 175.306 285.363 171.205 289.5 167.36C293.195 163.984 297.095 160.841 301.18 157.95C305.08 155.17 308.97 152.68 312.87 150.28C316.77 147.88 320.65 145.59 324.55 143.28L336.25 136.56L337.94 135.56"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 493.36L-233.65 427.36L-223.09 421.27L-211.15 414.38L-199.21 407.48L-187.5 400.68L-175.82 393.94L-164.13 387.19L-152.45 380.44L-140.76 373.7C-136.867 371.46 -132.977 369.226 -129.09 367C-125.19 364.77 -121.29 362.56 -117.4 360.42C-113.51 358.28 -109.62 356.2 -105.73 354.32C-101.933 352.447 -98.0294 350.798 -94.04 349.38C-90.2485 348.034 -86.3326 347.07 -82.35 346.5C-78.4817 345.992 -74.5727 345.868 -70.68 346.13C-66.78 346.35 -62.89 346.87 -58.99 347.32C-55.1232 347.84 -51.2189 348.028 -47.32 347.88C-43.2988 347.646 -39.3463 346.733 -35.63 345.18C-31.3975 343.332 -27.4615 340.869 -23.95 337.87C-19.7547 334.265 -15.8493 330.337 -12.27 326.12C-8.37999 321.63 -4.48 316.7 -0.589996 311.73C3.3 306.76 7.19 301.8 11.09 297.2C14.99 292.6 18.87 288.42 22.77 284.66C26.4888 281.093 30.405 277.738 34.5 274.61C38.39 271.61 42.28 268.96 46.18 266.43C50.08 263.9 53.97 261.53 57.87 259.21C61.77 256.89 65.65 254.6 69.55 252.33C73.45 250.06 77.33 247.82 81.23 245.56L92.92 238.81L104.6 232.06L116.29 225.32L127.95 218.56C131.86 216.32 135.76 214.1 139.64 211.94C143.52 209.78 147.43 207.66 151.32 205.74C155.101 203.816 159.007 202.145 163.01 200.74C170.493 198.06 178.549 197.394 186.37 198.81C190.27 199.45 194.16 200.47 198.04 201.15C201.883 201.926 205.825 202.091 209.72 201.64C213.906 201.002 217.896 199.437 221.4 197.06C225.741 194.038 229.668 190.461 233.08 186.42C236.97 182 240.86 176.83 244.76 171.52C248.66 166.21 252.54 160.76 256.44 155.84C260.058 151.216 263.959 146.821 268.12 142.68C271.789 139.056 275.69 135.675 279.8 132.56C283.7 129.61 287.59 127 291.48 124.56C295.37 122.12 299.27 119.75 303.17 117.45C307.07 115.15 310.95 112.9 314.85 110.64C318.75 108.38 322.65 106.14 326.54 103.88L337.94 97.2998"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 455.15L-266.73 408.23L-256.17 402.14L-244.24 395.25L-232.29 388.35L-220.57 381.56L-208.88 374.81L-197.2 368.07L-185.5 361.37C-181.6 359.14 -177.7 356.91 -173.81 354.74C-169.92 352.57 -166.02 350.45 -162.13 348.5C-158.356 346.557 -154.473 344.835 -150.5 343.34C-146.721 341.923 -142.807 340.894 -138.82 340.27C-134.953 339.711 -131.036 339.58 -127.14 339.88C-123.24 340.15 -119.34 340.8 -115.45 341.36C-111.592 342.012 -107.682 342.303 -103.77 342.23C-99.7349 342.074 -95.7641 341.168 -92.06 339.56C-87.8045 337.637 -83.8661 335.078 -80.38 331.97C-76.1846 328.247 -72.2799 324.209 -68.7 319.89C-64.8 315.32 -60.91 310.31 -57.01 305.35C-53.11 300.39 -49.23 295.47 -45.34 290.98C-41.6584 286.703 -37.7565 282.621 -33.65 278.75C-29.9366 275.262 -26.0376 271.978 -21.97 268.91C-18.09 265.97 -14.19 263.32 -10.29 260.81C-6.39001 258.3 -2.50999 255.93 1.39001 253.6C5.29001 251.27 9.17001 249 13.07 246.73L24.75 239.96L36.44 233.21L48.12 226.47L59.8 219.72L71.5 212.96L83.19 206.21L94.87 199.47L106.57 192.73C110.47 190.49 114.36 188.25 118.25 186.06C122.14 183.87 126.04 181.68 129.93 179.67C133.725 177.659 137.624 175.85 141.61 174.25C145.371 172.718 149.292 171.614 153.3 170.96C157.168 170.405 161.092 170.365 164.97 170.84C168.86 171.28 172.76 172.17 176.65 172.94C180.481 173.817 184.4 174.253 188.33 174.24C192.395 174.126 196.383 173.101 200 171.24C204.358 168.893 208.306 165.853 211.69 162.24C215.879 157.806 219.777 153.106 223.36 148.17C227.25 142.99 231.15 137.52 235.05 132.43C238.95 127.34 242.83 122.62 246.73 118.43C250.373 114.55 254.272 110.919 258.4 107.56C262.149 104.516 266.051 101.666 270.09 99.0202C273.98 96.4502 277.87 94.0201 281.77 91.7301C285.67 89.4401 289.56 87.1302 293.45 84.8602L305.13 78.1102L316.82 71.3501C320.71 69.1101 324.6 66.8502 328.5 64.6102L337.94 59.1602"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-240.328 584L-101.328 503.74L-90.7681 497.64L-78.8381 490.75L-66.8981 483.86L-55.1681 477.09L-43.4981 470.34L-31.7681 463.56L-20.0981 456.82L-8.40813 450.07L3.27187 443.33L14.9519 436.58C18.8519 434.34 22.7452 432.093 26.6319 429.84L38.3219 423.1L50.0019 416.35C53.8886 414.103 57.7819 411.856 61.6819 409.61L73.3619 402.86L85.0419 396.12L96.7219 389.39C100.609 387.156 104.505 384.936 108.412 382.73C112.302 380.54 116.192 378.38 120.082 376.29C123.972 374.2 127.872 372.22 131.772 370.41C135.672 368.6 139.552 366.95 143.442 365.53C147.27 364.122 151.172 362.927 155.132 361.95C159.022 360.95 162.912 360.29 166.802 359.73C170.692 359.17 174.592 358.73 178.492 358.35C182.392 357.97 186.272 357.5 190.172 356.9C194.104 356.329 198.003 355.548 201.852 354.56C205.821 353.487 209.724 352.185 213.542 350.66C217.432 349.12 221.332 347.35 225.222 345.41C229.112 343.47 233.012 341.41 236.912 339.14C240.812 336.87 244.702 334.55 248.602 332.04C252.502 329.53 256.392 326.83 260.292 323.91C264.192 320.99 268.092 317.82 271.972 314.35C275.852 310.88 279.772 307.09 283.652 303.14C287.532 299.19 291.462 295.03 295.342 290.86C299.222 286.69 303.142 282.42 307.022 278.41C310.902 274.4 314.822 270.54 318.702 267C322.582 263.46 326.492 260.17 330.382 257.16C332.902 255.2 335.422 253.346 337.942 251.6"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 111.34L-343.08 108.5L-331.4 101.76L-319.73 95.02L-308.04 88.27L-296.37 81.56L-284.68 74.81L-273 68.07L-261.32 61.33L-249.63 54.56L-237.94 47.81L-226.26 41.06L-214.57 34.32L-202.88 27.56L-191.2 20.81L-179.5 14.07L-167.81 7.32L-156.15 0.559998L-144.5 -6.17001L-132.82 -12.91L-121.14 -19.65L-109.43 -26.44L-97.76 -33.18L-86.08 -39.92L-74.4 -46.66L-62.72 -53.41L-51.03 -60.15C-47.1433 -62.3967 -43.25 -64.6433 -39.35 -66.89L-27.67 -73.63C-23.77 -75.86 -19.88 -78.09 -15.99 -80.27C-12.1 -82.45 -8.18999 -84.6 -4.29999 -86.58C-0.501479 -88.5486 3.39715 -90.3177 7.38 -91.88C9.38 -92.64 11.33 -93.31 13.29 -93.88C15.1862 -94.4287 17.1128 -94.8661 19.06 -95.19C22.9235 -95.8157 26.8477 -95.9801 30.75 -95.68C31.75 -95.6 32.75 -95.51 33.75 -95.38C34.75 -95.25 35.75 -95.13 36.68 -94.98C38.62 -94.7 40.56 -94.37 42.5 -94.07C43.5 -93.93 44.43 -93.78 45.41 -93.65C46.39 -93.52 47.41 -93.41 48.36 -93.31C50.3802 -93.112 52.4118 -93.0552 54.44 -93.14C56.3996 -93.235 58.3488 -93.4825 60.27 -93.88C62.3544 -94.3192 64.3932 -94.9519 66.36 -95.77C67.24 -96.14 68.12 -96.55 69.01 -97.02C69.9 -97.49 70.78 -98.02 71.67 -98.57C72.56 -99.12 73.44 -99.74 74.32 -100.39C75.02 -100.9 75.71 -101.39 76.4 -102"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 149.56L-345 147.86L-333.31 141.11L-321.63 134.37L-310 127.56L-298.32 120.82C-294.427 118.573 -290.533 116.326 -286.64 114.08L-274.96 107.33L-263.28 100.59L-251.6 93.8498L-239.92 87.0998L-228.24 80.3598L-216.5 73.6498L-204.82 66.8998L-193.12 60.1498L-181.5 53.4098L-169.81 46.6598L-158.12 39.9098L-146.44 33.1698L-134.76 26.4198L-123.08 19.6798L-111.4 12.9298L-99.72 6.1898L-88.04 -0.550194L-76.36 -7.30019L-64.68 -14.0302L-53 -20.7802L-41.33 -27.5202L-29.64 -34.2702L-17.96 -41.0102C-14.0733 -43.2502 -10.18 -45.4835 -6.28 -47.7102C-2.39 -49.9302 1.51 -52.1302 5.41 -54.2502C9.31 -56.3702 13.2 -58.3802 17.09 -60.1602C20.8595 -61.9395 24.7694 -63.4044 28.78 -64.5402C32.6012 -65.5871 36.5385 -66.1515 40.5 -66.2202C44.4186 -66.2346 48.3307 -65.8999 52.19 -65.2202C54.13 -64.9002 56.06 -64.5302 58 -64.2202C59 -64.0502 59.94 -63.8902 60.92 -63.7502C61.9 -63.6102 62.92 -63.4702 63.92 -63.3702C65.8087 -63.1568 67.7103 -63.0799 69.61 -63.1402C71.6338 -63.2099 73.6448 -63.4915 75.61 -63.9802C76.6058 -64.2418 77.5871 -64.5555 78.55 -64.9202C79.5744 -65.3062 80.576 -65.7503 81.55 -66.2502C82.55 -66.7602 83.55 -67.3302 84.55 -67.9702C85.55 -68.6102 86.55 -69.3202 87.55 -70.0802C89.6814 -71.7405 91.7086 -73.5306 93.62 -75.4402C95.62 -77.4402 97.55 -79.5202 99.43 -81.6902C101.31 -83.8602 103.04 -86.0202 104.81 -88.2902C106.58 -90.5602 108.28 -92.8502 110 -95.1402C111.72 -97.4302 113.42 -99.7302 115.09 -101.95"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 187.75L-347 187.17L-335.32 180.43L-323.63 173.68L-311.95 166.94L-300.27 160.19L-288.59 153.45L-276.91 146.71L-265.22 139.96L-253.55 133.22L-241.86 126.47L-230.19 119.73L-218.5 112.99L-206.82 106.24C-202.92 103.993 -199.023 101.743 -195.13 99.4896L-183.5 92.7496C-179.6 90.5029 -175.703 88.2529 -171.81 85.9996L-160.12 79.2596L-148.4 72.5596L-136.72 65.8096L-125.03 59.0596L-113.35 52.3196L-101.66 45.5596L-89.99 38.8196L-78.3 32.0696L-66.63 25.3296C-62.73 23.0896 -58.8367 20.8429 -54.95 18.5896L-43.26 11.8496L-31.6 5.10957L-19.9 -1.64043L-8.23001 -8.44043L3.5 -15.1504C7.39 -17.3804 11.29 -19.6104 15.18 -21.7904C19.07 -23.9704 22.96 -26.1004 26.86 -28.0704C30.6396 -30.0233 34.5257 -31.7627 38.5 -33.2804C42.2796 -34.6802 46.1937 -35.6855 50.18 -36.2804C54.0545 -36.8167 57.9795 -36.8838 61.87 -36.4804C65.76 -36.1004 69.65 -35.2804 73.54 -34.6004C77.3885 -33.8417 81.3085 -33.5064 85.23 -33.6004C87.1523 -33.6933 89.0611 -33.9712 90.93 -34.4304C91.9452 -34.677 92.9467 -34.9774 93.93 -35.3304C94.9537 -35.7069 95.9553 -36.1409 96.93 -36.6304C97.93 -37.1204 98.93 -37.6304 99.93 -38.2904C100.42 -38.6004 100.93 -38.9204 101.41 -39.2904C101.89 -39.6604 102.41 -39.9904 102.9 -40.3504C103.9 -41.0904 104.85 -41.8804 105.82 -42.7104C106.79 -43.5404 107.74 -44.4204 108.67 -45.3404C110.77 -47.3404 112.83 -49.6304 114.81 -51.9504C115.81 -53.1004 116.81 -54.2904 117.74 -55.4804C118.67 -56.6704 119.67 -57.8904 120.61 -59.1104C121.55 -60.3304 122.61 -61.7304 123.61 -63.0404L126.61 -67.0404L129.61 -71.0404C130.61 -72.3504 131.61 -73.6904 132.61 -74.9804C136.08 -79.5104 139.45 -83.6504 143.18 -87.7804C146.842 -91.8684 150.718 -95.7605 154.79 -99.4404C155.74 -100.29 156.68 -101.13 157.63 -101.94"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-348 416.95C-331.94 407.683 -315.877 398.413 -299.81 389.14L-289.25 383.03L-277.32 376.15L-265.38 369.25L-253.65 362.48L-241.96 355.75C-238.07 353.52 -234.17 351.29 -230.27 349.1C-226.37 346.91 -222.49 344.76 -218.6 342.73C-214.71 340.7 -210.81 338.81 -206.92 337.22C-203.14 335.663 -199.232 334.438 -195.24 333.56C-191.397 332.729 -187.471 332.35 -183.54 332.43C-179.626 332.604 -175.728 333.032 -171.87 333.71C-168.009 334.407 -164.108 334.858 -160.19 335.06C-156.23 335.232 -152.272 334.697 -148.5 333.48C-144.25 331.995 -140.296 329.77 -136.82 326.91C-132.554 323.404 -128.639 319.493 -125.13 315.23C-121.24 310.65 -117.34 305.48 -113.45 300.38C-109.56 295.28 -105.67 290.23 -101.77 285.62C-98.1042 281.25 -94.2052 277.08 -90.09 273.13C-86.3852 269.614 -82.4857 266.309 -78.41 263.23C-74.51 260.28 -70.62 257.63 -66.72 255.12C-62.82 252.61 -58.94 250.26 -55.05 247.95C-51.16 245.64 -47.26 243.36 -43.36 241.1C-39.46 238.84 -35.58 236.59 -31.69 234.34L-20.01 227.56L-8.32999 220.82L3.35001 214.07L15.04 207.33L26.72 200.58L38.41 193.83L50.1 187.08L61.79 180.33L73.5 173.62L85.18 166.88C89.0933 164.633 92.99 162.4 96.87 160.18C100.77 157.96 104.66 155.77 108.55 153.68C112.44 151.59 116.34 149.6 120.23 147.9C123.994 146.224 127.899 144.886 131.9 143.9C135.722 142.972 139.649 142.552 143.58 142.65C147.514 142.827 151.425 143.343 155.27 144.19C159.116 145.094 163.013 145.762 166.94 146.19C170.887 146.553 174.867 146.096 178.63 144.85C182.92 143.3 186.879 140.956 190.3 137.94C194.553 134.177 198.452 130.033 201.95 125.56C205.84 120.76 209.74 115.42 213.64 110.19C217.54 104.96 221.42 99.8599 225.32 95.2899C228.954 90.9987 232.855 86.9407 237 83.1399C240.704 79.7817 244.604 76.6462 248.68 73.7499C252.58 70.9499 256.47 68.4399 260.37 66.0299C264.27 63.6199 268.15 61.3199 272.05 59.0299C275.95 56.7399 279.84 54.4799 283.73 52.2299L295.42 45.4699L307.15 38.6999L319.08 31.8099L331.01 24.9199L337.94 20.9199"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="103.445" y="95">
        CPU
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_10359)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="41.041" y="168.6">
        60%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="85.1953" y="199.8">
        Address:&#10;
      </tspan>
      <tspan x="80.2559" y="222.8">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_10359)">
      <rect x="288" y="171" width="800" height="451" rx="12" fill="#181A1B" />
    </g>
    <rect opacity="0.3" x="288" y="350" width="800" height="24" fill="#FD0054" />
    <rect opacity="0.1" x="337" y="208" width="1" height="414" fill="white" />
    <text
      opacity="0.4"
      fill="white"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="304.184" y="239.938">
        73&#10;
      </tspan>
      <tspan x="304.184" y="260.938">
        74&#10;
      </tspan>
      <tspan x="304.184" y="281.938">
        75&#10;
      </tspan>
      <tspan x="304.184" y="302.938">
        76&#10;
      </tspan>
      <tspan x="304.184" y="323.938">
        77&#10;
      </tspan>
      <tspan x="304.184" y="344.938">
        78&#10;
      </tspan>
      <tspan x="304.184" y="365.938">
        79&#10;
      </tspan>
      <tspan x="304.184" y="386.938">
        80&#10;
      </tspan>
      <tspan x="304.184" y="407.938">
        81&#10;
      </tspan>
      <tspan x="304.184" y="428.938">
        82&#10;
      </tspan>
      <tspan x="304.184" y="449.938">
        83&#10;
      </tspan>
      <tspan x="304.184" y="470.938">
        84&#10;
      </tspan>
      <tspan x="304.184" y="491.938">
        85&#10;
      </tspan>
      <tspan x="304.184" y="512.938">
        86&#10;
      </tspan>
      <tspan x="304.184" y="533.938">
        87&#10;
      </tspan>
      <tspan x="304.184" y="554.938">
        88&#10;
      </tspan>
      <tspan x="304.184" y="575.938">
        89&#10;
      </tspan>
      <tspan x="304.184" y="596.938">
        90
      </tspan>
    </text>
    <path
      d="M288 183C288 176.373 293.373 171 300 171H1076C1082.63 171 1088 176.373 1088 183V207H288V183Z"
      fill="#181A1B"
    />
    <text
      fill="white"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="672.359" y="193.9">
        Rust
      </tspan>
    </text>
    <circle cx="310" cy="189" r="6" fill="#FD0054" />
    <circle cx="330" cy="189" r="6" fill="#FFB31A" />
    <circle cx="350" cy="189" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="288" y="207" width="800" height="1" fill="white" />
    <text
      fill="white"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="412.449" y="260.938">
        {' '}
      </tspan>
      <tspan x="471.307" y="260.938">
        (xs:{' '}
      </tspan>
      <tspan x="538.572" y="260.938">
        &#60;
      </tspan>
      <tspan x="572.205" y="260.938">
        &#60;$kind&#62;&#62;, k:{' '}
      </tspan>
      <tspan x="723.553" y="260.938">
        ) -&#62;{' '}
      </tspan>
      <tspan x="790.818" y="260.938">
        &#60;
      </tspan>
      <tspan x="841.268" y="260.938">
        &#62; {'{'}&#10;
      </tspan>
      <tspan x="362" y="281.938">
        {' '}
      </tspan>
      <tspan x="454.49" y="281.938">
        (xs.
      </tspan>
      <tspan x="513.348" y="281.938">
        (){' '}
      </tspan>
      <tspan x="555.389" y="281.938">
        {' '}
        k);&#10;
      </tspan>
      <tspan x="362" y="302.938" />
      <tspan x="362" y="323.938">
        {' '}
      </tspan>
      <tspan x="420.857" y="323.938">
        {' '}
        n_per_cluster:{' '}
      </tspan>
      <tspan x="614.246" y="323.938">
        {' '}
        xs.
      </tspan>
      <tspan x="673.104" y="323.938">
        (){' '}
      </tspan>
      <tspan x="706.736" y="323.938">
        {' '}
        k;&#10;
      </tspan>
      <tspan x="362" y="344.938">
        {' '}
      </tspan>
      <tspan x="420.857" y="344.938">
        {' '}
        centroids:{' '}
      </tspan>
      <tspan x="580.613" y="344.938">
        &#60;$kind
      </tspan>
      <tspan x="362" y="365.938">
        {'        '}(
      </tspan>
      <tspan x="446.082" y="365.938">
        ..k).
      </tspan>
      <tspan x="513.348" y="365.938">
        (
      </tspan>
      <tspan x="530.164" y="365.938">
        j
      </tspan>
      <tspan x="546.98" y="365.938">
        {' '}
        xs[j{' '}
      </tspan>
      <tspan x="605.838" y="365.938">
        {' '}
        n_per_cluster].
      </tspan>
      <tspan x="782.41" y="365.938">
        ()).
      </tspan>
      <tspan x="874.9" y="365.938">
        ();&#10;
      </tspan>
      <tspan x="362" y="386.938" />
      <tspan x="362" y="407.938">
        {' '}
      </tspan>
      <tspan x="454.49" y="407.938">
        {' '}
        clustering{' '}
      </tspan>
      <tspan x="563.797" y="407.938">
        {' '}
      </tspan>
      <tspan x="715.145" y="407.938">
        (
      </tspan>
      <tspan x="731.961" y="407.938">
        xs,{' '}
      </tspan>
      <tspan x="774.002" y="407.938">
        centroids);&#10;
      </tspan>
      <tspan x="362" y="428.938" />
      <tspan x="362" y="449.938">
        {' '}
      </tspan>
      <tspan x="429.266" y="449.938">
        {' '}
        {'{'}&#10;
      </tspan>
      <tspan x="362" y="470.938">
        {' '}
      </tspan>
      <tspan x="454.49" y="470.938">
        {' '}
        centroids{' '}
      </tspan>
      <tspan x="555.389" y="470.938">
        {' '}
      </tspan>
      <tspan x="723.553" y="470.938">
        (
      </tspan>
      <tspan x="740.369" y="470.938">
        xs,{' '}
      </tspan>
      <tspan x="782.41" y="470.938">
        clustering, k);&#10;
      </tspan>
      <tspan x="362" y="491.938">
        {' '}
      </tspan>
      <tspan x="454.49" y="491.938">
        {' '}
        new_clustering{' '}
      </tspan>
      <tspan x="597.43" y="491.938">
        {' '}
      </tspan>
      <tspan x="748.777" y="491.938">
        (
      </tspan>
      <tspan x="765.594" y="491.938">
        xs,{' '}
      </tspan>
      <tspan x="807.635" y="491.938">
        centroids);&#10;
      </tspan>
      <tspan x="362" y="512.938" />
      <tspan x="362" y="533.938">
        {' '}
      </tspan>
      <tspan x="446.082" y="533.938">
        {' '}
        new_clustering&#10;
      </tspan>
      <tspan x="362" y="554.938">
        {' '}
      </tspan>
      <tspan x="504.939" y="554.938">
        ()&#10;
      </tspan>
      <tspan x="362" y="575.938">
        {' '}
      </tspan>
      <tspan x="496.531" y="575.938">
        (clustering.
      </tspan>
      <tspan x="631.062" y="575.938">
        ())&#10;
      </tspan>
      <tspan x="362" y="596.938">
        {'            '}.
      </tspan>
      <tspan x="496.531" y="596.938">
        (
      </tspan>
      <tspan x="513.348" y="596.938">
        (
      </tspan>
      <tspan x="530.164" y="596.938">
        za,{' '}
      </tspan>
      <tspan x="572.205" y="596.938">
        zb)| za{' '}
      </tspan>
      <tspan x="656.287" y="596.938">
        {' '}
        zb)
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="362" y="239.938">
        /// Assign the N D-dimensional data, `xs`, to `k` clusters using K-Means clustering&#10;
      </tspan>
    </text>
    <text
      fill="#FFD500"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="362" y="260.938">
        pub fn
      </tspan>
      <tspan x="513.348" y="260.938">
        Vec
      </tspan>
      <tspan x="546.98" y="260.938">
        Vec
      </tspan>
      <tspan x="681.512" y="260.938">
        usize
      </tspan>
      <tspan x="765.594" y="260.938">
        Vec
      </tspan>
      <tspan x="799.227" y="260.938">
        usize
      </tspan>
      <tspan x="538.572" y="281.938">
        &#62;=
      </tspan>
      <tspan x="395.633" y="323.938">
        let
      </tspan>
      <tspan x="555.389" y="323.938">
        usize =
      </tspan>
      <tspan x="698.328" y="323.938">
        /
      </tspan>
      <tspan x="395.633" y="344.938">
        let
      </tspan>
      <tspan x="521.756" y="344.938">
        Vec&#60;Vec
      </tspan>
      <tspan x="631.062" y="344.938">
        &#62;&#62; =&#10;
      </tspan>
      <tspan x="521.756" y="365.938">
        |
      </tspan>
      <tspan x="538.572" y="365.938">
        |
      </tspan>
      <tspan x="597.43" y="365.938">
        *
      </tspan>
      <tspan x="395.633" y="407.938">
        let mut
      </tspan>
      <tspan x="555.389" y="407.938">
        =
      </tspan>
      <tspan x="723.553" y="407.938">
        &#38;
      </tspan>
      <tspan x="765.594" y="407.938">
        &#38;
      </tspan>
      <tspan x="395.633" y="449.938">
        loop
      </tspan>
      <tspan x="429.266" y="470.938">
        let
      </tspan>
      <tspan x="546.98" y="470.938">
        =
      </tspan>
      <tspan x="731.961" y="470.938">
        &#38;
      </tspan>
      <tspan x="774.002" y="470.938">
        &#38;
      </tspan>
      <tspan x="429.266" y="491.938">
        let
      </tspan>
      <tspan x="589.021" y="491.938">
        =
      </tspan>
      <tspan x="757.186" y="491.938">
        &#38;
      </tspan>
      <tspan x="799.227" y="491.938">
        &#38;
      </tspan>
      <tspan x="429.266" y="533.938">
        if
      </tspan>
      <tspan x="471.307" y="596.938">
        all
      </tspan>
      <tspan x="504.939" y="596.938">
        |
      </tspan>
      <tspan x="521.756" y="596.938">
        &#38;
      </tspan>
      <tspan x="563.797" y="596.938">
        &#38;
      </tspan>
      <tspan x="639.471" y="596.938">
        ==
      </tspan>
    </text>
    <text
      fill="#FD6A00"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="420.857" y="260.938">
        kmeans
      </tspan>
      <tspan x="488.123" y="281.938">
        len
      </tspan>
      <tspan x="647.879" y="323.938">
        len
      </tspan>
      <tspan x="488.123" y="365.938">
        map
      </tspan>
      <tspan x="740.369" y="365.938">
        clone
      </tspan>
      <tspan x="816.043" y="365.938">
        collect
      </tspan>
      <tspan x="572.205" y="407.938">
        nearest_centroids
      </tspan>
      <tspan x="563.797" y="470.938">
        recompute_centroids
      </tspan>
      <tspan x="605.838" y="491.938">
        nearest_centroids
      </tspan>
      <tspan x="462.898" y="554.938">
        .iter
      </tspan>
      <tspan x="462.898" y="575.938">
        .zip
      </tspan>
      <tspan x="597.43" y="575.938">
        iter
      </tspan>
    </text>
    <text
      fill="#F14AFF"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="395.633" y="281.938">
        assert!
      </tspan>
      <tspan x="437.674" y="365.938">
        0
      </tspan>
    </text>
    <path
      d="M1062.69 570.24L1060.08 568.628C1060.06 568.375 1060.03 568.123 1060.01 567.87L1062.25 565.784C1062.48 565.572 1062.58 565.258 1062.52 564.954C1062.49 564.804 1062.42 564.664 1062.32 564.548C1062.22 564.432 1062.09 564.343 1061.95 564.289L1059.09 563.22C1059.01 562.973 1058.94 562.727 1058.86 562.482L1060.65 560.005C1060.74 559.881 1060.79 559.736 1060.81 559.585C1060.83 559.433 1060.81 559.279 1060.75 559.138C1060.69 558.997 1060.6 558.873 1060.48 558.779C1060.36 558.684 1060.22 558.621 1060.06 558.597L1057.04 558.106C1056.93 557.879 1056.81 557.653 1056.68 557.429L1057.95 554.648C1058.01 554.509 1058.04 554.356 1058.03 554.204C1058.02 554.052 1057.97 553.905 1057.88 553.778C1057.8 553.651 1057.68 553.548 1057.54 553.478C1057.41 553.409 1057.26 553.375 1057.1 553.381L1054.04 553.488C1053.88 553.29 1053.72 553.094 1053.55 552.901L1054.26 549.92C1054.29 549.772 1054.29 549.617 1054.25 549.47C1054.21 549.323 1054.13 549.189 1054.02 549.081C1053.91 548.973 1053.78 548.894 1053.63 548.852C1053.48 548.811 1053.33 548.807 1053.18 548.842L1050.19 549.545C1050 549.381 1049.8 549.22 1049.6 549.061L1049.71 546.001C1049.72 545.849 1049.68 545.697 1049.61 545.561C1049.54 545.425 1049.44 545.309 1049.31 545.224C1049.19 545.139 1049.04 545.088 1048.89 545.076C1048.73 545.064 1048.58 545.091 1048.44 545.155L1045.66 546.422C1045.43 546.299 1045.21 546.178 1044.98 546.059L1044.49 543.044C1044.46 542.893 1044.4 542.751 1044.3 542.632C1044.21 542.512 1044.08 542.419 1043.94 542.36C1043.8 542.302 1043.65 542.281 1043.5 542.298C1043.34 542.316 1043.2 542.372 1043.08 542.461L1040.59 544.244C1040.35 544.166 1040.1 544.092 1039.85 544.021L1038.78 541.161C1038.73 541.018 1038.64 540.89 1038.52 540.791C1038.41 540.692 1038.27 540.624 1038.12 540.594C1037.97 540.564 1037.81 540.573 1037.67 540.62C1037.52 540.667 1037.39 540.751 1037.29 540.863L1035.2 543.102C1034.94 543.074 1034.69 543.048 1034.44 543.028L1032.82 540.424C1032.74 540.294 1032.63 540.187 1032.5 540.113C1032.36 540.039 1032.21 540 1032.06 540C1031.91 540 1031.76 540.039 1031.62 540.113C1031.49 540.187 1031.38 540.294 1031.3 540.424L1029.68 543.028C1029.43 543.048 1029.17 543.074 1028.92 543.102L1026.83 540.863C1026.73 540.751 1026.6 540.668 1026.45 540.621C1026.3 540.574 1026.15 540.565 1026 540.595C1025.85 540.625 1025.71 540.692 1025.59 540.791C1025.48 540.891 1025.39 541.018 1025.33 541.161L1024.26 544.021C1024.02 544.092 1023.77 544.167 1023.52 544.244L1021.04 542.461C1020.92 542.372 1020.77 542.316 1020.62 542.299C1020.47 542.281 1020.32 542.303 1020.17 542.361C1020.03 542.419 1019.91 542.513 1019.81 542.632C1019.72 542.751 1019.66 542.893 1019.63 543.044L1019.14 546.059C1018.91 546.177 1018.69 546.299 1018.46 546.422L1015.67 545.155C1015.54 545.091 1015.38 545.064 1015.23 545.077C1015.08 545.089 1014.93 545.14 1014.8 545.225C1014.55 545.397 1014.39 545.691 1014.41 546.001L1014.51 549.061C1014.31 549.22 1014.12 549.381 1013.92 549.545L1010.94 548.842C1010.79 548.807 1010.63 548.811 1010.49 548.853C1010.34 548.895 1010.21 548.973 1010.1 549.081C1009.99 549.189 1009.91 549.323 1009.87 549.47C1009.83 549.616 1009.82 549.772 1009.86 549.92L1010.56 552.901C1010.4 553.094 1010.24 553.29 1010.08 553.488L1007.01 553.381C1006.86 553.375 1006.71 553.409 1006.57 553.478C1006.44 553.548 1006.32 553.651 1006.23 553.778C1006.15 553.905 1006.1 554.052 1006.09 554.204C1006.07 554.356 1006.1 554.509 1006.16 554.648L1007.43 557.429C1007.31 557.653 1007.19 557.879 1007.07 558.106L1004.05 558.597C1003.9 558.621 1003.76 558.684 1003.64 558.779C1003.52 558.874 1003.42 558.997 1003.37 559.138C1003.31 559.279 1003.29 559.433 1003.3 559.585C1003.32 559.736 1003.38 559.881 1003.47 560.005L1005.25 562.482C1005.18 562.727 1005.1 562.973 1005.03 563.22L1002.16 564.289C1002.02 564.343 1001.89 564.432 1001.79 564.548C1001.69 564.664 1001.63 564.804 1001.6 564.954C1001.57 565.104 1001.58 565.259 1001.62 565.404C1001.67 565.549 1001.75 565.68 1001.87 565.784L1004.11 567.87C1004.08 568.122 1004.05 568.375 1004.03 568.628L1001.43 570.24C1001.3 570.32 1001.19 570.432 1001.11 570.565C1001.04 570.698 1001 570.848 1001 571.001C1001 571.154 1001.04 571.304 1001.11 571.437C1001.19 571.571 1001.3 571.683 1001.43 571.763L1004.03 573.374C1004.05 573.627 1004.08 573.88 1004.11 574.132L1001.87 576.219C1001.75 576.323 1001.67 576.454 1001.62 576.599C1001.58 576.744 1001.57 576.899 1001.6 577.049C1001.63 577.198 1001.7 577.338 1001.79 577.454C1001.89 577.57 1002.02 577.659 1002.16 577.713L1005.03 578.782C1005.1 579.03 1005.18 579.276 1005.25 579.52L1003.47 581.998C1003.38 582.122 1003.32 582.267 1003.3 582.418C1003.28 582.57 1003.31 582.724 1003.37 582.865C1003.42 583.006 1003.52 583.13 1003.64 583.224C1003.76 583.319 1003.9 583.381 1004.05 583.406L1007.07 583.896C1007.19 584.125 1007.31 584.35 1007.43 584.574L1006.16 587.354C1006.1 587.493 1006.07 587.646 1006.09 587.798C1006.1 587.95 1006.15 588.097 1006.24 588.224C1006.41 588.483 1006.7 588.634 1007.01 588.621L1010.08 588.514C1010.24 588.713 1010.4 588.908 1010.56 589.102L1009.86 592.083C1009.79 592.385 1009.88 592.701 1010.1 592.921C1010.32 593.142 1010.64 593.23 1010.94 593.159L1013.92 592.457C1014.12 592.622 1014.31 592.782 1014.51 592.939L1014.41 596C1014.4 596.152 1014.43 596.304 1014.5 596.44C1014.57 596.576 1014.68 596.692 1014.8 596.776C1014.93 596.861 1015.08 596.912 1015.23 596.924C1015.38 596.936 1015.54 596.909 1015.67 596.846L1018.46 595.579C1018.68 595.703 1018.91 595.824 1019.14 595.942L1019.63 598.956C1019.66 599.106 1019.72 599.248 1019.81 599.368C1019.91 599.487 1020.03 599.581 1020.17 599.639C1020.31 599.698 1020.47 599.719 1020.62 599.702C1020.77 599.684 1020.92 599.629 1021.04 599.54L1023.52 597.755C1023.77 597.833 1024.02 597.908 1024.26 597.98L1025.33 600.838C1025.44 601.129 1025.69 601.344 1026 601.403C1026.15 601.433 1026.3 601.424 1026.45 601.377C1026.6 601.33 1026.73 601.247 1026.83 601.135L1028.92 598.898C1029.17 598.927 1029.43 598.951 1029.68 598.974L1031.3 601.576C1031.38 601.706 1031.49 601.813 1031.62 601.887C1031.76 601.961 1031.91 602 1032.06 602C1032.21 602 1032.36 601.961 1032.5 601.887C1032.63 601.813 1032.74 601.706 1032.82 601.576L1034.44 598.974C1034.69 598.952 1034.94 598.926 1035.2 598.898L1037.29 601.135C1037.5 601.363 1037.81 601.464 1038.12 601.403C1038.27 601.373 1038.41 601.306 1038.52 601.207C1038.64 601.108 1038.73 600.981 1038.78 600.838L1039.85 597.98C1040.1 597.908 1040.35 597.833 1040.59 597.755L1043.07 599.54C1043.2 599.629 1043.34 599.685 1043.5 599.702C1043.65 599.72 1043.8 599.698 1043.94 599.64C1044.08 599.581 1044.21 599.488 1044.3 599.368C1044.4 599.248 1044.46 599.106 1044.48 598.956L1044.98 595.942C1045.21 595.824 1045.43 595.701 1045.66 595.579L1048.44 596.846C1048.58 596.909 1048.73 596.936 1048.89 596.924C1049.04 596.912 1049.19 596.861 1049.31 596.776C1049.44 596.692 1049.54 596.576 1049.61 596.44C1049.68 596.304 1049.72 596.152 1049.71 596L1049.6 592.939C1049.8 592.781 1050 592.622 1050.19 592.457L1053.18 593.159C1053.33 593.194 1053.48 593.191 1053.63 593.149C1053.78 593.108 1053.91 593.029 1054.02 592.921C1054.24 592.701 1054.33 592.385 1054.26 592.083L1053.55 589.102C1053.72 588.908 1053.88 588.713 1054.04 588.514L1057.1 588.621C1057.25 588.627 1057.41 588.594 1057.54 588.524C1057.68 588.454 1057.79 588.351 1057.88 588.224C1058.05 587.966 1058.08 587.637 1057.95 587.354L1056.68 584.574C1056.8 584.35 1056.93 584.125 1057.04 583.896L1060.06 583.406C1060.21 583.381 1060.36 583.319 1060.48 583.224C1060.6 583.129 1060.69 583.006 1060.75 582.864C1060.81 582.723 1060.83 582.57 1060.81 582.418C1060.79 582.266 1060.74 582.122 1060.65 581.998L1058.86 579.52C1058.94 579.276 1059.01 579.03 1059.09 578.782L1061.95 577.713C1062.24 577.604 1062.46 577.353 1062.52 577.048C1062.55 576.899 1062.54 576.744 1062.49 576.599C1062.44 576.453 1062.36 576.323 1062.25 576.219L1060.01 574.132C1060.03 573.88 1060.06 573.627 1060.08 573.374L1062.69 571.763C1062.82 571.683 1062.93 571.571 1063 571.437C1063.08 571.304 1063.11 571.154 1063.11 571.001C1063.11 570.849 1063.08 570.699 1063 570.565C1062.93 570.432 1062.82 570.32 1062.69 570.24ZM1045.24 591.832C1044.76 591.729 1044.34 591.44 1044.07 591.029C1043.81 590.618 1043.72 590.119 1043.82 589.641C1043.87 589.404 1043.97 589.18 1044.11 588.981C1044.24 588.782 1044.42 588.611 1044.62 588.48C1044.82 588.348 1045.05 588.258 1045.29 588.215C1045.53 588.171 1045.77 588.175 1046.01 588.226C1046.49 588.329 1046.91 588.617 1047.17 589.028C1047.44 589.438 1047.53 589.937 1047.43 590.415C1047.32 590.893 1047.04 591.31 1046.63 591.576C1046.21 591.842 1045.71 591.934 1045.24 591.832ZM1044.35 585.85C1044.13 585.804 1043.91 585.801 1043.69 585.841C1043.48 585.88 1043.27 585.963 1043.08 586.083C1042.9 586.203 1042.74 586.358 1042.61 586.54C1042.49 586.721 1042.4 586.926 1042.35 587.142L1041.43 591.454C1038.48 592.786 1035.29 593.472 1032.06 593.468C1028.75 593.472 1025.49 592.753 1022.49 591.363L1021.57 587.051C1021.52 586.835 1021.43 586.631 1021.31 586.449C1021.18 586.268 1021.02 586.112 1020.83 585.992C1020.65 585.873 1020.44 585.79 1020.22 585.751C1020.01 585.711 1019.78 585.714 1019.57 585.76L1015.75 586.578C1015.05 585.849 1014.39 585.074 1013.78 584.257H1032.34C1032.55 584.257 1032.69 584.219 1032.69 584.029V577.476C1032.69 577.285 1032.55 577.247 1032.34 577.247H1026.91V573.094H1032.78C1033.32 573.094 1035.65 573.247 1036.39 576.218C1036.63 577.132 1037.14 580.106 1037.49 581.057C1037.84 582.125 1039.26 584.257 1040.77 584.257H1050.02C1050.13 584.257 1050.24 584.246 1050.36 584.224C1049.71 585.094 1049.01 585.917 1048.25 586.687L1044.35 585.85ZM1018.68 591.742C1018.45 591.793 1018.2 591.796 1017.96 591.753C1017.72 591.709 1017.5 591.619 1017.29 591.488C1017.09 591.356 1016.91 591.186 1016.78 590.987C1016.64 590.788 1016.54 590.563 1016.49 590.327C1016.39 589.849 1016.48 589.35 1016.75 588.939C1017.01 588.528 1017.43 588.239 1017.91 588.136C1018.38 588.046 1018.87 588.144 1019.28 588.411C1019.68 588.677 1019.96 589.09 1020.06 589.561C1020.16 590.032 1020.07 590.524 1019.82 590.932C1019.56 591.339 1019.15 591.63 1018.68 591.742ZM1011.64 563.246C1011.84 563.693 1011.85 564.2 1011.68 564.656C1011.5 565.113 1011.15 565.48 1010.7 565.679C1010.48 565.777 1010.24 565.831 1010 565.837C1009.76 565.843 1009.52 565.801 1009.29 565.714C1009.07 565.626 1008.86 565.496 1008.68 565.329C1008.51 565.162 1008.37 564.962 1008.27 564.741C1008.07 564.294 1008.06 563.787 1008.24 563.331C1008.41 562.874 1008.76 562.507 1009.21 562.308C1009.43 562.21 1009.67 562.156 1009.91 562.15C1010.15 562.144 1010.39 562.186 1010.62 562.273C1010.85 562.36 1011.05 562.491 1011.23 562.658C1011.4 562.825 1011.54 563.025 1011.64 563.246ZM1009.48 568.366L1013.45 566.604C1013.86 566.423 1014.18 566.087 1014.34 565.671C1014.5 565.256 1014.49 564.793 1014.31 564.386L1013.49 562.539H1016.71V577.019H1010.21C1009.64 574.996 1009.35 572.904 1009.35 570.801C1009.35 569.978 1009.39 569.165 1009.48 568.366ZM1026.91 566.96V562.692H1034.58C1034.97 562.692 1037.37 563.148 1037.37 564.939C1037.37 566.426 1035.53 566.959 1034.02 566.959H1026.91V566.96ZM1054.77 570.801C1054.77 571.368 1054.74 571.928 1054.7 572.484H1052.37C1052.14 572.484 1052.05 572.637 1052.05 572.865V573.933C1052.05 576.447 1050.63 576.994 1049.38 577.133C1048.2 577.266 1046.88 576.638 1046.72 575.914C1046.02 571.989 1044.86 571.151 1043.02 569.702C1045.3 568.255 1047.68 566.12 1047.68 563.263C1047.68 560.177 1045.56 558.234 1044.11 557.28C1042.09 555.947 1039.84 555.68 1039.24 555.68H1015.14C1018.41 552.04 1022.84 549.461 1027.85 548.523L1030.69 551.497C1030.84 551.657 1031.02 551.785 1031.22 551.874C1031.42 551.963 1031.64 552.012 1031.86 552.017C1032.08 552.022 1032.3 551.983 1032.51 551.904C1032.72 551.824 1032.9 551.704 1033.06 551.552L1036.24 548.518C1042.9 549.755 1048.54 553.893 1051.79 559.569L1049.61 564.474C1049.43 564.882 1049.42 565.344 1049.58 565.76C1049.74 566.175 1050.06 566.511 1050.47 566.692L1054.66 568.549C1054.73 569.291 1054.77 570.041 1054.77 570.801ZM1030.69 545.993C1030.86 545.826 1031.07 545.695 1031.29 545.607C1031.52 545.52 1031.76 545.478 1032 545.483C1032.25 545.489 1032.48 545.542 1032.71 545.64C1032.93 545.737 1033.13 545.878 1033.29 546.053C1033.63 546.407 1033.82 546.88 1033.8 547.369C1033.79 547.858 1033.59 548.322 1033.23 548.66C1033.06 548.827 1032.85 548.958 1032.63 549.046C1032.4 549.133 1032.16 549.175 1031.92 549.17C1031.67 549.164 1031.44 549.111 1031.21 549.013C1030.99 548.915 1030.79 548.775 1030.63 548.599C1030.29 548.245 1030.1 547.772 1030.12 547.284C1030.13 546.795 1030.33 546.331 1030.69 545.993ZM1052.28 563.336C1052.37 563.114 1052.51 562.915 1052.69 562.748C1052.87 562.581 1053.07 562.45 1053.3 562.363C1053.52 562.276 1053.76 562.234 1054.01 562.24C1054.25 562.246 1054.49 562.3 1054.71 562.398C1055.16 562.597 1055.51 562.964 1055.68 563.421C1055.86 563.877 1055.85 564.384 1055.65 564.831C1055.55 565.052 1055.41 565.252 1055.23 565.419C1055.06 565.586 1054.85 565.717 1054.63 565.804C1054.4 565.891 1054.16 565.933 1053.92 565.927C1053.67 565.921 1053.44 565.867 1053.21 565.769C1052.77 565.57 1052.42 565.202 1052.24 564.746C1052.07 564.29 1052.08 563.783 1052.28 563.336Z"
      fill="white"
    />
    <path
      d="M288 362L124 362L124 284M124 284L133.625 295.625M124 284L114.375 295.625"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_10359"
        x="248"
        y="151"
        width="880"
        height="531"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_10359" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_10359"
          result="effect2_dropShadow_1112_10359"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_10359"
          result="effect3_dropShadow_1112_10359"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_10359"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_10359"
        x1="248"
        y1="28"
        x2="-2.70614e-06"
        y2="276"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.253937" stopColor="#57F906" />
        <stop offset="0.732284" stopColor="#00CCC0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_10359"
        x1="228"
        y1="48"
        x2="20"
        y2="256"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.253937" stopColor="#57F906" />
        <stop offset="0.732284" stopColor="#00CCC0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_10359"
        x1="208"
        y1="104"
        x2="42.4686"
        y2="183.074"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.123543" stopColor="#57F906" />
        <stop offset="0.703356" stopColor="#00CCC0" />
      </linearGradient>
    </defs>
  </svg>
);

Rust.propTypes = {
  className: PropTypes.string,
};

Rust.defaultProps = {
  className: null,
};

export default Rust;
